// getters
const retaineds = state => state.retaineds

export default {
  retaineds
}



// WEBPACK FOOTER //
// ./src/store/modules/retaineds/getters.js